export default "__VITE_ASSET__2aae3184__"